import {
  SupportedTypeUpload,
  SUPPORTED_UPLOAD_TYPES
} from 'common/enum/supported-upload-types'
import { UPLOAD_CONFIG, ERROR_MESSAGES } from './upload-config'

export class ValidationError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'ValidationError'
  }
}

export class FileValidator {
  validateFileType(file: File): void {
    const fileType = file.type as SupportedTypeUpload

    if (!UPLOAD_CONFIG.SUPPORTED_UPLOAD_TYPES.includes(fileType)) {
      throw new ValidationError(ERROR_MESSAGES.UNSUPPORTED_FILE_TYPE)
    }
  }

  validateFileSize(file: File): void {
    if (file.size > UPLOAD_CONFIG.MAX_FILE_SIZE) {
      throw new ValidationError(ERROR_MESSAGES.FILE_TOO_LARGE)
    }
  }

  getSupportedMimeTypes(): readonly SupportedTypeUpload[] {
    return SUPPORTED_UPLOAD_TYPES
  }
}
